import { Route, Routes } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';

import FilMenage from './messagesMenage/FilMenage';
import ListeFils from './messagesMenage/ListeFils';

/**
 * La messagerie interne du ménage — femmes de chambre ↔ gouvernance, technique,
 * réception — chaque message dans la langue de qui le lit. Distincte de la
 * « Messagerie » (les clients de l'hôtel). Remontée à neuf au changement d'hôtel.
 */
export default function MessagesMenage() {
    const { currentFacility } = useStateContext();
    const cleEtablissement = String(currentFacility?.id ?? 'aucun');

    return (
        <Routes>
            <Route index element={<ListeFils key={cleEtablissement} />} />
            <Route path=":threadId" element={<FilMenage key={cleEtablissement} />} />
        </Routes>
    );
}
